import styled from 'styled-components'

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`

export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  height: 100%;
  gap: 0.3rem;
  flex-direction: column;
  width: ${(props) => (props.width ? props.width : '100%')};
`

export const Title = styled.label`
  font-size: ${(props) => props.theme.font.textbase};
  color: #494949;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-end;
  gap: 1rem;
`
